import { render, staticRenderFns } from "./subscribe-form.vue?vue&type=template&id=bbd9fe68&scoped=true"
import script from "./subscribe-form.vue?vue&type=script&lang=js"
export * from "./subscribe-form.vue?vue&type=script&lang=js"
import style0 from "./subscribe-form.vue?vue&type=style&index=0&id=bbd9fe68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd9fe68",
  null
  
)

export default component.exports